module.exports = __webpack_public_path__ + "static/media/logo_instarlike.0b4893a1.svg";